"use client";

import {useState} from "react";
import {Dropdown} from "react-bootstrap";
import {User} from "@/entities/user";
import {useAuthStore} from "@/features/auth";
import {useMessagesStore} from "@/entities/message";
import {useChatStore} from "@/entities/chat";
import {formatPhone} from "@/shared/ui";
import { Link } from "react-router-dom";

type Props = {
  user: User;
};

export const UserMenu = ({ user }: Props) => {
  const [show, setShow] = useState(false);

  const { logout } = useAuthStore(state => state);
  const { clearChats } = useChatStore();
  const { clearMessage } = useMessagesStore();

  const logoutHandler = () => {
    clearChats();
    clearMessage();
    logout();
  };

  return (
    <Dropdown align="end" show={show} onToggle={(isOpen) => setShow(isOpen)}>
      <Dropdown.Toggle
        as="div"
        onClick={() => setShow(!show)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer",
          padding: "0 4px",
        }}
      >
        {user?.avatarUrl ? (
          <img
            src={user?.avatarUrl}
            alt="avatar"
            style={{
              width: 28,
              height: 28,
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        ) : (
          <div
            style={{
              width: 28,
              height: 28,
              borderRadius: "50%",
              backgroundColor: "#6c757d",
              color: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
              fontSize: 14,
            }}
          >
            {user.firstName?.[0]?.toUpperCase()}
          </div>
        )}

        <span style={{ fontSize: 14, color: "#212529" }}>
          {user.firstName}
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu style={{ minWidth: 220, zIndex: 1301, padding: "10px", backgroundColor: "#fff" }}>
        <div style={{ marginBottom: "8px" }}>
          <div style={{ display: "flex", alignItems: "start", gap: "8px", marginBottom: 4 }}>
            {user?.avatarUrl ? (
              <img
                src={user?.avatarUrl}
                alt="avatar"
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            ) : (
              <div
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  backgroundColor: "#6c757d",
                  color: "white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                {user.firstName?.[0]?.toUpperCase()}
              </div>
            )}

            <div>
              <div style={{ fontSize: 12, color: "#495057" }}>Имя: {user.firstName}</div>
              <div style={{ fontSize: 12, color: "#495057" }}>Фамилия: {user.lastName}</div>
              <div style={{ fontSize: 12, color: "#495057" }}>Телефон: {formatPhone(user.phone)}</div>
              <div style={{ fontSize: 12, color: "#495057" }}>Дата регистрации:</div>
              <div style={{ fontSize: 12, color: "#495057" }}>
                {new Date(user.createdAt).toLocaleString()}
              </div>

              <Link
                to="/profile"
                style={{ color: "#495057", fontSize: 12 }}
                onClick={() => setShow(false)} 
              >
                Перейти в профиль
              </Link>
            </div>
          </div>
        </div>

        <Dropdown.Divider />

        <Dropdown.Item
          onClick={() => {
            const confirmed = window.confirm("Вы уверены, что хотите выйти?");
            if (confirmed) {
              logoutHandler();
              localStorage.removeItem("token");
            }
          }}
          style={{ backgroundColor: "transparent", color: "#212529" }}
          onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#e9ecef")}
          onMouseLeave={e => (e.currentTarget.style.backgroundColor = "transparent")}
        >
          Выйти
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
